export const greenTheme = `
html .dropdown-title:hover {
    color: #22ba6e
}

html .dropdown-option:hover label {
    color: #22ba6e
}

html .time-cell {
    color: #433560;
}

html .title-cell {
    color: #9da0b3;
}

html .page {
    background: linear-gradient(32deg, #22ba6e, #00aae7);
}

html .dropdown-title {
    background: transparent;
}

html .dropdown-title i {
    color: #22ba6e
}

html .dropdown-options {
    border-color: #dddee3;
}

html .dropdown-option label {
    border: 0;
    color: #9da0b3;
}

html .dropdown-option label .fa {
    color: white;
}

html .dropdown-option label:hover {}

html .dropdown-option input:checked+label {
    background: transparent;
    color: #22ba6e;
}

html .dropdown-option input:checked+label:hover {}

html .select-date-start {
    color: #1A1A18;
}

html input.date-week-picker:hover~.select-date-start {
    color: #22ba6e;
}

html .right-arrow__top,
html .right-arrow__bottom,
html .left-arrow__top,
html .left-arrow__bottom {
    background-color: #6A7075;
}

html .select-date-select {
    border-color: #C4C9D6;
}

.select-date-button {
    border-color: #27b975;
    color: #9da0b3;
}

html .right-arrow__label {
    color: #1A1A18;
}

html .right-arrow:hover .right-arrow__label {
    color: #22ba6e;
}

html .select-date-button-alt {
    color: #1A1A18;
}

html .select-date-button-alt:hover {
    color: #22ba6e;
}

html .headItem .marker {
    color: #9da0b3;
}

html .modal .cross__left,
html .modal .cross__right {
    background-color: #989BAF;
}

html .right-arrow:hover .right-arrow__top,
html .right-arrow:hover .right-arrow__bottom {
    background-color: #22ba6e;
}

html .left-arrow:hover .left-arrow__top,
html .left-arrow:hover .left-arrow__bottom {
    background-color: #22ba6e;
}

html .modal .modal-title {
    color: #433560;
}

html .modal .modal-name {
    color: #9DA0B3;
}

html .modal .modal-item {
    color: #000;
}

html .form-item_validation-error {
    color: #d62445;
}

@media (max-width: 768px) {
    html .active .title-cell {
        color: #9da0b3;
    }

    html .active {
        background: #e7ecf2;
    }
}

@media (min-width: 801px) {
    html .form-item_input {
        border-bottom-color: #199c5b;
    }

    html .form-item_input::-webkit-input-placeholder {
        color: #000;
    }

    html .form-item_input::-moz-placeholder {
        color: #000;
    }

    html .form-item_input:-moz-placeholder {
        color: #000;
    }

    html .form-item_input:-ms-input-placeholder {
        color: #000;
    }
}

@media (max-width: 800px) {
    html .modal .modal-item {
        color: #9da0b3;
        background: white;
    }

    html .form-item_input {
        border-bottom-color: white;
    }

    html .modal .modal-title {
        color: #433560;
    }

    html .modal .modal-name {
        color: #9DA0B3;
    }
}`;
